import {ResearchLitElement, html, css} from '@core/research-lit-element';

import '@bog-design-system/bd-standard-button';
import '@bog-design-system/bd-button';
import '@bog-design-system/bd-account-switcher';

import '../layout/research-section.js';
import './research-hamburger-menu';

import config from '../../config/config';

class researchHeader extends ResearchLitElement {
    static get is() {
        return 'research-header';
    }

    static get styles() {
        return css`
            .container {
                display: flex;
                justify-content: space-between;
                align-items: center;
                background-color: var(--color-white-solid-10);
                width: 100%;
                height: var(--space-48);
                padding: var(--space-16) 0;
            }

            .left-container {
                display: flex;
                column-gap: var(--space-40);
                align-items: center;
            }

            .menu {
                display: flex;
                column-gap: var(--space-64);
            }

            .menu-item {
                color: var(--color-invert-component-tr-30);
            }

            .active {
                color: #FF600A;
            }

            .right-container {
                display: flex;
            }

            .language {
                display: flex;
                align-items: center;
            }

            .language-selector {
                color: var(--color-invert-component-tr-30);
            }

            research-section {
                --section-background-color: var(--color-white-solid-10);
            }

            .hamburger-menu-tab {
                display: none;
            }

            research-hamburger-menu {
                display: none;
            }

            .hamburger-active {
                right: 0;
                transition: 1s;
            }

            .header-divider {
                height: 1px;
                background: var(--color-invert-component-tr-70);
                width: 100%;
            }
            
            .logo {
                height: var(--space-40);
            }

            .logo .image {
                height: 100%;
            }

            @media (max-width: 768px) {
                .hamburger-menu-tab {
                    display: block;
                    cursor: pointer;
                }

                .hamburger-menu-icon {
                    --icon-color: var(--color-invert-component-tr-40);
                    margin-left: var(--space-12);
                }

                .menu {
                    display: none;
                }

                research-hamburger-menu {
                    display: block;
                }

                .language {
                    margin-right: 20px;
                }
            }
            
            @media (max-width: 600px) {
                .logo {
                    height: var(--space-64);
                }
            }
        `;
    }

    render() {
        return html`
            <research-section no-pad-top no-pad-bottom>
                <div class="container">
                    <div class="left-container">
                        <a class="logo" href="${this._logoLink(this.data?.menu)}">
                            <img
                                    class="image"
                                    src="${this._getLogo()}"
                                    alt="logo"
                            />
                        </a>
                        <div class="menu">
                            ${this.data?.menu?.length > 0 ? this.data.menu.map((item) => html`
                                <bd-font type="body2">
                                    <a  class="${this.active.includes(item?.url?.link) ? 'active' : 'menu-item'}"
                                        href="${item?.url?.link}"
                                        target="${item?.url?.target}">
                                        ${item?.label}
                                    </a>
                                </bd-font>
                            `) : ''}
                        </div>
                    </div>
                    
                    <div class="right-container">
                        <div class="language">
                            <bd-standard-button
                                    @click=${this._languageChange}
                                    class="language-selector"
                                    type="text-low"
                                    mini
                            >
                                ${this.selectedLanguageLabel}
                            </bd-standard-button>
                        </div>

                        <div class="hamburger-menu-tab">
                            <bd-button
                                    type="secondary"
                                    mini
                                    icon="bd:menu"
                                    icon-only
                                    class="hamburger-menu-icon"
                                    id="hamburger-button"
                                    @click=${this._hamburgerClick}>
                            </bd-button>
                        </div>
                    </div>
                    
                </div>
            </research-section>
            ${ this._isTablet ? html`<div class="header-divider"></div>` : `` }
            <research-hamburger-menu
                    id="hamburger"
                    .menuItemsData="${this.data?.menu}"
                    .active="${this.active}"
                    @close-hamburger-menu="${() => this._onHamburgerIconChange('menu')}">
            </research-hamburger-menu>
        `;
    }

    static get properties() {
        return {
            selectedLanguage: {
                type: Boolean,
            },
            data: {
                type: Object,
            },
            active: {
                type: String,
                reflect: true,
            },
        };
    }

    constructor() {
        super();
        this.langArray = [
            {
                name: 'ქართული',
                shortName: 'Geo',
                value: 'ka',
            },
            {
                name: 'English',
                shortName: 'Eng',
                value: 'en',
            },
        ];
        this.selectedLanguage = 'ka';
        this.selectedLanguageLabel = 'Eng';
        this.data = {};
        this.active = '';
        this._isTablet = window.matchMedia(`(max-width: 768px)`).matches;
    }

    connectedCallback() {
        super.connectedCallback();
        this.isMobile = window.matchMedia(`(max-width: 600px)`).matches;

        this.selectedLanguage = localStorage.getItem('language') || 'ka';
        this.selectedLanguageLabel = this.langArray.find((item) => item.value !== this.selectedLanguage).shortName;

        this.apiCall(`common/application-data?contentType=App.Common.Header`).then((res) => {
            this.data = res.json.data;
        });

        this.activeMenuItem = window.location.href;
    }


    _languageChange() {
        const newPath = this._getLanguagePath();
        if (newPath) {
            location.pathname = newPath;
        }
    }

    _getLanguagePath() {
        this.selectedLanguage = this.langArray.find((item) => item.value !== this.selectedLanguage).value;
        if (this.selectedLanguage) {
            const currentLangIndex = config.languages.indexOf(this.selectedLanguage);
            const lang = config.languages[currentLangIndex] ? config.languages[currentLangIndex] : config.languages[0];
            localStorage.setItem('language', lang);
            const path = location.pathname.split('/');
            if (config.languages.includes(path[1])) {
                path[1] = lang;
                return path.join('/');
            } else {
                return location.pathname;
            }
        }
        return '';
    }

    _setSelectedItems() {
        if (!this.route || !this.leftMenu || !this.leftMenu.length) {
            return;
        }
        if (this.route === '/') {
            const first = this.leftMenu[0];
            this.route = first.link.url.link;
            history.replaceState(null, null, this.route);
        }
        const route = this._formatRoute(this.route);
        const routes = this._findLinkNode(route);
        if (!routes) {
            return;
        }

        const segmentNode = routes.segment;
        const subMenuItemNode = routes.subMenuItem;
        const megaMenuItem = routes.megaMenuItem;

        this.routeElement = segmentNode?.link?.title;

        if (segmentNode && segmentNode.menuItemLinks && segmentNode.menuItemLinks.length) {
            segmentNode.menuItemLinks.forEach((item) => {
                if (window.location.href.includes(item.link.url.link)) {
                    this.selectedSegment = item.link.title;
                }
            });
        } else this.selectedSegment = segmentNode ? segmentNode.link.title : '';

        this.subMenu = segmentNode && segmentNode.menuItemLinks ? segmentNode.menuItemLinks: [];

        if (subMenuItemNode) {
            this.subMenuItem = subMenuItemNode.link.title;
        }

        if (megaMenuItem) {
            this.megaMenuSelectedItem = megaMenuItem.link.title;
        } else {
            this.megaMenuSelectedItem = '';
        }
    }

    _hamburgerClick() {
        this.shadowRoot.getElementById('hamburger').classList.toggle('hamburger-active');

        if (this.shadowRoot.getElementById('hamburger').classList.contains('hamburger-active')) {
            this._onHamburgerIconChange('close');
        } else {
            this._onHamburgerIconChange('menu');
        }
    }

    _onHamburgerIconChange(state) {
        const button = this.shadowRoot.getElementById('hamburger-button');
        button.setAttribute('icon', '');

        if (state === 'close') {
            button.style.cssText = '--icon-size: var(--space-12);';
        } else {
            button.style.cssText = '--icon-size: 16px;';
        }

        setTimeout(() => {
            button.setAttribute('icon', state);
        }, 100);
    }


    _logoLink(menu) {
        return menu?.[0]?.url?.link ? menu[0].url.link : '/';
    }

    _getLogo() {
        return this.isMobile ? 'assets/logos/logo_frame.svg' : `assets/logos/bank_of_georgia_${this.lang}.svg`;
    }
}

window.customElements.define(researchHeader.is, researchHeader);
